export enum AuthActionTypes {
  AUTH_BY_QR_CODE = '@auth/AUTH_BY_QR_CODE',
  AUTH_BY_USERNAME = '@auth/AUTH_BY_USERNAME',
  AUTH_FAILURE = '@auth/AUTH_FAILURE',
  AUTH_FORGOT_PASSWORD = '@auth/AUTH_FORGOT_PASSWORD',
  AUTH_FORGOT_PASSWORD_FAILURE = '@auth/AUTH_FORGOT_PASSWORD_FAILURE',
  AUTH_FORGOT_PASSWORD_SUCCESS = '@auth/AUTH_FORGOT_PASSWORD_SUCCESS',
  AUTH_LOGOUT = '@auth/AUTH_LOGOUT',
  AUTH_SUCCESS = '@auth/AUTH_SUCCESS'
}

export interface AuthByQRCodeRequest {
  user_key: string
}

export interface AuthByUsernameRequest {
  password: string
  username: string
}

export interface AuthForgotPassword {
  username: string
}

export interface AuthResponse {
  access_token: string
  refresh_token: string
}

export interface RecoverPasswordType {
  exception?: string
  message?: string
  reason?: string
}

interface ForgotPasswordType {
  message: string
  type: 'success' | 'info' | 'warning' | 'error'
}
export interface AuthState {
  readonly access_token: string | null
  readonly error: boolean
  readonly forgot_password: ForgotPasswordType | null
  readonly loading: boolean
  readonly refresh_token: string | null
}
